import { PaginateQuery } from "core/resources/types/shared";
import { CategoriaFinanceiraResponse } from "core/features/contas-categorias/typings";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import { TipoContatoEnum } from "core/features/auth/typings/user";
import { TipoUnidadePessoaEnum } from "core/features/unidades/typings/unidade";
import { TipoDataConta } from "core/features/conta/typings";
import { OperacaoEnum } from "core/resources/enums/conta";
import { MovimentacaoBancariaListagemResponse } from "core/features/movimentacoes-bancarias/typings";
import { FormaPagamento } from "resources/enums/tenant";
import {
  StatusReservaEnum,
  ReservaFiltroTipoData,
  ReservaCriacaoOrigem,
} from "features/reservas/typings";
import { TipoDocumentoEnum } from "core/resources/enums/conta";
import { TenantTipoHabitacao } from "core/resources/enums/tenant";

export enum RelatorioIdEnum {
  Email = "EED477BD-0E21-4D0E-8AF4-092EC3CB0000",
  Unidades = "DDD477BD-0E21-4D0E-8AF4-092EC3CB0001",
  Inadimplentes = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0002",
  Receitas = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0003",
  TotalDeDespesas = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0004",
  Demonstrativo = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0005",
  DemonstrativoAnual = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0006",
  MovimentacaoFinanceira = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0007",
  BalancoFinanceiro = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0009",
  ReceitasComComposicao = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0010",
  ComposicaoReceitasHorizontal = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0011",
  Reservas = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0012",
  DespesasComComposicao = "FFD477BD-0E21-4D0E-8AF4-092EC3CB0013",
}
export interface PDFRelatorioDespesasProps extends PDFRelatorioDespesasResponse {
  selectedFields?: RelatorioDespesaFields[];
  includeDocumentWrapper?: boolean;
}

export interface PDFRelatorioDespesasPaginaLinhaProps extends RelatorioBaseData {
  item: RelatorioDespesaItem;
  selectedFields?: RelatorioDespesaFields[];
}

export interface PDFRelatorioDespesasResponse extends RelatorioBaseData {
  items: RelatorioDespesaItem[];
  total: number;
}

export interface StatusDemomstrativo {
  id: DemonstrativoStatusEnum;
  nome: string;
}

export interface DemonstrativoReceitaEDespesaItem extends CategoriaFinanceiraResponse {
  valor: number;
  valorItems: number;
  porcentagem: number;
  categoriaFinanceiraPaiId: string;
  id: string;
  nome: string;
  breadcrumb: string;
  ordem: number;
  code: string;
  items: DemonstrativoReceitaEDespesaItem[];
}

export interface DemonstrativoReceitaEDespesaAnualItem extends DemonstrativoReceitaEDespesaItem {
  media: number;
  mediaTotal: number;
  meses: {
    mes: string;
    valor: number;
    total: number;
  }[];
  items: DemonstrativoReceitaEDespesaAnualItem[];
}

export interface DemonstrativoReceitaEDespesaTransferencia {
  id: string;
  valor: number;
  data: string;
  contaOrigem: string;
  contaDestino: string;
}

export interface RelatorioDemonstrativoReceitaDespesaTotais {
  receita: number;
  despesa: number;
  resultado: number;
  saldo: number;
  saldoInicial: number;
  saldoHoje: number;
  totalCentroDeCustoInicioPeriodo?: number;
  totalCentroDeCusto?: number;
}
export interface RelatorioDemonstrativoReceitaDespesaResponse {
  receitas: DemonstrativoReceitaEDespesaItem[];
  despesas: DemonstrativoReceitaEDespesaItem[];
  transferencias: DemonstrativoReceitaEDespesaTransferencia[];
  totais: RelatorioDemonstrativoReceitaDespesaTotais;
}

export interface RelatorioDemonstrativoReceitaDespesaAnualResponse {
  receitas: DemonstrativoReceitaEDespesaAnualItem[];
  despesas: DemonstrativoReceitaEDespesaAnualItem[];
  transferencias: DemonstrativoReceitaEDespesaTransferencia[];
  totais: RelatorioDemonstrativoReceitaDespesaTotais;
}

export type RelatorioDemonstrativoReceitaDespesaPdfResponse =
  RelatorioBaseData &
    RelatorioDemonstrativoReceitaDespesaResponse & {
      dataSaldoInicio: string;
      dataSaldoFim: string;
    };

export type RelatorioDemonstrativoReceitaDespesaAnualPdfResponse =
  RelatorioBaseData & RelatorioDemonstrativoReceitaDespesaAnualResponse;

export type PDFRelatorioMovimentacaoBancariaResponse = RelatorioBaseData &
  MovimentacaoBancariaListagemResponse;
export interface FiltroRelatorioReceitaDespesa extends PaginateQuery {
  statusId: DemonstrativoStatusEnum | undefined;
  contaCategoriaIds: string[] | undefined;
  contaBancariaIds: string[] | undefined;
  centrosDeCustoIds: string[] | undefined;
  dataInicio: string;
  dataFim: string;
  operacao?: OperacaoEnum;
}

export interface FiltroRelatorioBalancoFinanceiro {
  contaCategoriaIds: string[] | undefined;
  contaBancariaIds: string[] | undefined;
  dataInicio: string;
  dataFim: string;
  search?: string;
  operacao?: OperacaoEnum;
}

export interface FiltroRelatorioReceitaDespesaAnual {
  search?: string;
  statusId: DemonstrativoStatusEnum | undefined;
  contaCategoriaIds: string[] | undefined;
  contaBancariaIds: string[] | undefined;
  ano: string;
  operacao?: OperacaoEnum;
}

export type RelatorioDespesaFields =
  | "dataVencimento"
  | "dataPagamento"
  | "pessoaNome"
  | "descricao"
  | "documento"
  | "valor"
  | "anexos"
  | "contaCategoria"
  | "nossoNumero";

export type RelatorioVotosFields =
  | "perguntaTitulo"
  | "perguntaTotalVotos"
  | "perguntaTotalPeso"
  | "opcaoTitulo"
  | "opcaoTotalVotos"
  | "opcaoTotalPeso"
  | "votanteNome"
  | "votanteUnidades"
  | "votantePesoTotal"
  | "votanteDataVoto";

export type ContasRecorrentesFields = "resumoContaCategoria";

export type RelatorioReceitasFields =
  | "nomeCondomino"
  | "unidade"
  | "resumoContaCategoria"
  | "centroDeCusto"
  | "valor"
  | "descricao"
  | "credito"
  | "geracao"
  | "vencimento"
  | "liquidacao"
  | "nossoNumero";

export type RelatorioUnidadesFields =
  | "documento"
  | "contatos"
  | "tipoUnidadePessoaId"
  | "area"
  | "areaConstruida"
  | "endereco"
  | "fracao"
  | "peso"
  | "observacao";

export type RelatorioContasComComposicaoFields =
  | "categoria"
  | "nossoNumero"
  | "complemento"
  | "competencia"
  | "dataCriacao"
  | "dataVencimento"
  | "dataPagamento"
  | "dataMovimentacao"
  | "centroDeCusto"
  | "valor"
  | "descricao"
  | "resumoContaCategoria"
  | "formaPagamento"
  | "tenantConta"
  | "pessoaOperadorAcordo";

export type RelatorioInadimplentesFields =
  | "unidade"
  | "responsavel"
  | "dataVencimento"
  | "dataCompetencia"
  | "descricao"
  | "principal"
  | "multa"
  | "juros"
  | "valorTaxaCobranca"
  | "valorCorrecaoMonetaria"
  | "diasAtraso"
  | "total"
  | "resumoContaCategoria"
  | "composicoes"
  | "dashboard"
  | "dataPosicao"
  | "dataEmissao"
  | "nossoNumero";

export interface RelatorioDespesaItem {
  id: string;
  anexos: {
    referencia: string;
    tipo?: string;
    nome: string;
    mimetype: string;
  }[];
  contasCategorias: {
    id: string;
    breadcrumb: string;
    nome: string;
    valor: number;
  }[];
  anexosPdf: string[];
  descricao: string;
  dataVencimento: string;
  dataPagamento: string | null;
  valorPago: number | null;
  documento: string;
  tipoDocumento: TipoDocumentoEnum;
  valor: number;
  nossoNumero: string | null;
  pessoa: {
    id: string;
    nome: string;
  };
}
export interface RelatorioDespesaResponse {
  items: RelatorioDespesaItem[];
  total: number;
}

export interface DespesaQuery extends PaginateQuery {
  search?: string;
  pessoaId?: string;
  categoriaIds?: string[];
  contaBancariaIds?: string[];
  centrosDeCustoIds?: string[];
  pago?: number;
  dataInicio?: string;
  dataFim?: string;
  despesasIds?: string[];
  tipoData?: TipoDataConta;
  rateioFechamentoId?: string;
}

export enum DemonstrativoStatusEnum {
  Receita = 1,
  Despesa = 2,
}

export enum StatusEmail {
  Waiting = "waiting",
  Processed = "processed",
  Delivered = "delivered",
  Error = "error",
  Deferred = "deferred",
  Bounce = "bounce",
  Blocked = "blocked",
  Dropped = "dropped",
  Open = "open",
  Click = "click",
  SpamReport = "spamReport",
  Unsubscribe = "unsubscribe",
  Unknown = "unknown",
}

export enum EmailTagEnum {
  Success = "success",
  Danger = "danger",
}
export interface EmailItemResponse {
  id: string;
  assunto: string;
  data: string;
  dataEntregue: string | null;
  dataVisualizacao: string | null;
  email: string;
  nome: string;
  status: StatusEmail;
  tag: string;
  tagType: EmailTagEnum;
}

export interface EmailHistoricoLog {
  title: StatusEmail;
  data: string;
  message?: string | null;
}

export interface ListarFiltroEmailQuery extends PaginateQuery {
  assuntos: string[];
  tipoDestinoId?: TipoDestinoEnum;
  destinoId?: string;
  dataInicio: string;
  dataFim: string;
  email?: string;
  status?: FiltroStatusEmail;
}

export interface DashboardRelatorioEmailResponse {
  visualizados: number;
  naoVisualizados: number;
  enviados: number;
  erro: number;
}

export enum FiltroStatusEmail {
  Todos = "todos",
  Lidos = "lidos",
  NaoLidos = "nao-lidos",
  Enviados = "enviados",
  NaoEnviados = "nao-enviados",
  Erro = "erro",
}

export interface RelatorioTenantInfo {
  logo: string;
  logoAdm?: string;
  endereco1: string;
  endereco2: string;
  nomeTenant: string;
}
export interface RelatorioBaseData extends RelatorioTenantInfo {
  periodo?: string;
  assinaturas?: { cargoNome?: string; pessoaNome?: string }[];
}

export interface RelatorioEmailPdfDataResponse extends RelatorioBaseData {
  emails: EmailItemResponse[];
}

export interface RelatorioInadimplentesQueryParams {
  search?: string;
  dataPosicao?: string;
  dataInicio?: string;
  dataFim?: string;
  cpf?: string;
  setor?: string;
  porcentagemHonorarios?: number;
  contasBancariasIds?: string[];
  centrosDeCustoIds?: string[];
  contasCategoriasIds?: string[];
}
export interface TotaisRelatorioInadimplentes {
  total: number;
  totalPrincipal: number;
  totalJuros: number;
  totalMulta: number;
  totalCorrecaoMonetaria: number;
  totalTaxaCobranca: number;
}

export interface DashboardInadimplentesResponse {
  numeroInadimplentes: number;
  totalUnidades: number;
  total: number;
  resumoPorCategoria?: ResumoCategoriaItem[];
  totalPrincipal: number;
  totalJuros: number;
  totalMulta: number;
  totalTaxaCobranca: number;
  totalCorrecaoMonetaria: number;
}

export interface RelatorioInadimplentesItem extends TotaisRelatorioInadimplentes {
  unidadeId: string;
  unidade: string;
  responsavel: string;
  isJuridico: boolean;
  isAjuizada: boolean;
  contas: ContasRelatorioInadimplentes[];
}

export interface ContasRelatorioInadimplentes {
  id: string;
  dataVencimento: string;
  dataCompetencia: string | null;
  descricao?: string | null;
  principal: number;
  juros: number;
  multa: number;
  valorTaxaCobranca: number;
  valorCorrecaoMonetaria: number;
  diasAtraso: number;
  honorarios: number;
  total: number;
  nossoNumero: string | null;
  composicoes: {
    id: string;
    valor: number;
    nome: string;
    breadcrumb: string;
    operacao: OperacaoEnum;
  }[];
}

export interface RelatorioInadimplentesResponse extends TotaisRelatorioInadimplentes {
  numeroInadimplentes: number;
  totalUnidades: number;
  items: RelatorioInadimplentesItem[];
  resumoPorCategoria?: ResumoCategoriaItem[];
  dataPosicao?: string;
}

export type RelatorioInadimplentesPdfResponse = RelatorioBaseData &
  RelatorioInadimplentesResponse;

export interface RelatorioUnidadesItem {
  fracao: number;
  area: number;
  areaConstruida: number | null;
  peso: number;
  unidadeId: string;
  unidade: string;
  observacao: string | null;
  pessoas: RelatorioUnidadePessoa[];
}

export interface RelatorioUnidadesPaginadoItem {
  fracao: number;
  area: number;
  areaConstruida: number;
  peso: number;
  unidadeId: string;
  unidade: string;
}

export interface RelatorioUnidadePdfItem {
  fracao: number;
  area: number;
  areaConstruida: number | null;
  peso: number;
  unidadeId: string;
  unidade: string;
  pessoa: RelatorioUnidadePessoa;
  observacao: string | null;
}

export interface RelatorioUnidadesQuery {
  search?: string;
  tipoUnidadePessoaIds?: TipoUnidadePessoaEnum[];
}

export interface RelatorioUnidadePessoa {
  id: string;
  nome: string;
  tipoUnidadePessoaId: string;
  tipoUnidadePessoaNome: string;
  endereco: string;
  documento: string;
  imagemUrl: string;
  contatos: {
    id: string;
    tipoContatoId: TipoContatoEnum;
    conteudo: string;
  }[];
}

export interface RelatorioUnidadesResponse {
  totalPessoas: number;
  items: RelatorioUnidadesItem[];
}

export interface RelatorioUnidadesTotais {
  totalPessoas: number;
}

export type RelatorioUnidadesPdfResponse = RelatorioBaseData &
  RelatorioUnidadesResponse;

export enum SetorContaInadimplencia {
  Juridico = "juridico",
  Administrativo = "administrativo",
}

export interface RelatorioReceitasPdfResponse
  extends RelatorioReceitasResponse, RelatorioBaseData {
  resumoPorCategoria: ResumoCategoriaItem[];
}
export interface RelatorioReceitasQueryParams {
  search?: string;
  emAberto?: boolean;
  liquidado?: boolean;
  dataInicio?: string;
  dataFim?: string;
  tipoData?: TipoDataConta;
  contasCategoriasIds?: string[];
  contasBancariasIds?: string[];
  centrosDeCustoIds?: string[];
  unidadesIds?: string[];
}

export interface RelatorioReceitasItem extends RelatorioReceitasQueryParams {
  unidadeId: string;
  unidade: string;
  valorTotal: number;
  proprietario: string;
  contas: ContasRelatorioReceitas[];
}

export interface RelatorioReceitasHorizontalQueryParams extends PaginateQuery {
  search?: string;
  dataInicio?: string;
  dataFim?: string;
  tipoData?: TipoDataConta;
  contasCategoriasIds?: string[];
  unidadesIds?: string[];
}

export interface ContasRelatorioReceitas {
  id: string;
  createdAt: string;
  dataMovimentacao: string | null;
  dataPagamento: string | null;
  dataVencimento: string;
  descricao: string | null;
  valor: number;
  nossoNumero: string | null;
  centroDeCusto: { id: string; nome: string } | null;
}

export interface RelatorioReceitasResponse {
  totalCobrancas: number;
  totalUnidades: number;
  totalPessoas: number;
  valorTotal: number;
  items: RelatorioReceitasItem[];
}

export interface TotaisRelatorioReceitas {
  totalCobrancas: number;
  totalUnidades: number;
  totalPessoas: number;
  valorTotal: number;
}

export interface ResumoCategoriaItem {
  id: string;
  breadcrumb: string;
  valor: number;
  nome: string;
  operacao?: OperacaoEnum;
}

export interface ContasRelatorioComposicaoReceitasHorizontal {
  id: string;
  descricao: string | null;
  dataVencimento: string;
  dataCompetencia: string;
  dataPagamento: string | null;
  dataMovimentacao: string | null;
  valor: number;
  nossoNumero: string | null;
  composicoes: Record<string, number>;
}
export interface RelatorioComposicaoReceitasHorizontalItem extends ContasRelatorioComposicaoReceitasHorizontal {
  unidadeId: string;
  unidade: string;
  blocoQuadra?: string | null;
  pessoa: string;
}

export interface RelatorioComposicaoReceitasHorizontalResponse {
  todasAsCategorias: { id: string; nome: string; breadcrumb: string }[];
  items: RelatorioComposicaoReceitasHorizontalItem[];
  resumoPorCategoria: {
    id: string;
    breadcrumb: string;
    valor: number;
    nome: string;
  }[];
}
export interface RelatorioComposicaoReceitasHorizontalPdfResponse
  extends RelatorioComposicaoReceitasHorizontalResponse, RelatorioBaseData {
  groupByFields?: string[];
}

export interface RelatorioAuditoriaQueryParams extends PaginateQuery {
  tipoEvento?: TipoEventoAuditoriaEnum;
  tenantsIds?: string[];
  usuarioId?: string;
  dataInicio?: string;
  dataFim?: string;
}

export enum TipoEventoAuditoriaEnum {
  Criacao = "criacao",
  Exclusao = "exclusao",
  Cancelamento = "cancelamento",
  Atualizacao = "atualizacao",
}

export interface RelatorioAuditoriaItem {
  id: string;
  acao: string;
  pessoa: {
    nome: string;
    documento: string;
    email: string;
  };
  descricao?: string;
  data: string;
  tenant: {
    id: string;
    nome: string;
  };
  entidade?: string;
  entidadeId?: string;
}

export interface AuditoriaDetailsResponse {
  id: string;
  data: string;
  pessoa: {
    nome: string;
    email: string;
    documento: string;
  };
  snapshot: any;
  tenant: { id: string; nome: string };
  acao: string;
  entidadeId?: string | null;
  entidade?: string;
  registro: any;
}

export interface ListaRelatoriosResponse {
  id: string;
  nome: string;
  pdfUrl?: string | null;
  items?: {
    id: string;
    nome: string;
    pdfUrl?: string | null;
  }[];
}

export enum GrupoRelatorioIdEnum {
  Email = "AAD477BD-0E21-4D0E-8AF4-092EC3CB0000",
  Unidades = "AAD477BD-0E21-4D0E-8AF4-092EC3CB0001",
  Financeiro = "AAD477BD-0E21-4D0E-8AF4-092EC3CB0002",
}
export interface ListaRelatoriosParams {
  grupoRelatoriosIds?: GrupoRelatorioIdEnum[];
}

export interface FieldRelatorioColumn<T = any> {
  label: string;
  value: T;
  defaultChecked?: boolean;
}

export const fieldsRelatorioDespesaColumns: FieldRelatorioColumn[] = [
  {
    label: "Data de vencimento",
    value: "dataVencimento",
  },
  {
    label: "Data de pagamento",
    value: "dataPagamento",
  },
  {
    label: "Favorecido",
    value: "pessoaNome",
  },
  {
    label: "Descrição",
    value: "descricao",
  },
  {
    label: "Documento",
    value: "documento",
  },
  {
    label: "Conta Categoria",
    value: "contaCategoria",
  },
  {
    label: "Valor",
    value: "valor",
  },
  {
    label: "Anexos",
    value: "anexos",
    defaultChecked: false,
  },
];

export const fieldsRelatorioReceitasOptions: FieldRelatorioColumn<RelatorioReceitasFields>[] =
  [
    {
      label: "Nome do condôminio",
      value: "nomeCondomino",
    },
    {
      label: "Unidade",
      value: "unidade",
    },
    {
      label: "Resumo por conta categoria",
      value: "resumoContaCategoria",
    },
    {
      label: "Descrição",
      value: "descricao",
    },
    {
      label: "Nosso Número",
      value: "nossoNumero",
    },
    {
      label: "Data de geração",
      value: "geracao",
    },
    {
      label: "Data de vencimento",
      value: "vencimento",
    },
    {
      label: "Data de liquidação",
      value: "liquidacao",
    },
    {
      label: "Data de crédito",
      value: "credito",
    },
    {
      label: "Centro de custo",
      value: "centroDeCusto",
    },
    {
      label: "Valor",
      value: "valor",
    },
  ];

export const fieldsRelatorioContasComComposicaoColumns: FieldRelatorioColumn<RelatorioContasComComposicaoFields>[] =
  [
    {
      label: "Categoria",
      value: "categoria",
    },
    {
      label: "Complemento",
      value: "complemento",
    },
    {
      label: "Data de criação",
      value: "dataCriacao",
    },
    {
      label: "Competência",
      value: "competencia",
    },
    {
      label: "Vencimento",
      value: "dataVencimento",
    },
    {
      label: "Liquidação",
      value: "dataPagamento",
    },
    {
      label: "Crédito",
      value: "dataMovimentacao",
    },
    {
      label: "Centro de custo",
      value: "centroDeCusto",
    },
    {
      label: "Valor",
      value: "valor",
    },
    {
      label: "Descrição",
      value: "descricao",
    },
    {
      label: "Nosso número",
      value: "nossoNumero",
    },
    {
      label: "Resumo por categoria",
      value: "resumoContaCategoria",
    },
    {
      label: "Forma de pagamento",
      value: "formaPagamento",
    },
    {
      label: "Conta bancária",
      value: "tenantConta",
    },
    {
      label: "Usuário operador",
      value: "pessoaOperadorAcordo",
    },
  ];

export const fieldsRelatorioInadimplentesColumns: FieldRelatorioColumn<RelatorioInadimplentesFields>[] =
  [
    {
      label: "Unidade",
      value: "unidade",
    },
    {
      label: "Proprietário",
      value: "responsavel",
    },
    {
      label: "Vencimento",
      value: "dataVencimento",
    },
    {
      label: "Composições",
      value: "composicoes",
    },
    {
      label: "Descrição",
      value: "descricao",
    },
    {
      label: "Competência",
      value: "dataCompetencia",
    },
    {
      label: "Nosso Número",
      value: "nossoNumero",
    },
    {
      label: "Principal",
      value: "principal",
    },
    {
      label: "Multa",
      value: "multa",
    },
    {
      label: "Juros",
      value: "juros",
    },
    {
      label: "Tx. Cobrança",
      value: "valorTaxaCobranca",
    },
    {
      label: "Correção monetária",
      value: "valorCorrecaoMonetaria",
    },
    {
      label: "Dias atraso",
      value: "diasAtraso",
    },
    {
      label: "Total",
      value: "total",
    },
    {
      label: "Data de emissão",
      value: "dataEmissao",
    },
    {
      label: "Data da posição",
      value: "dataPosicao",
    },
    {
      label: "Dashboard",
      value: "dashboard",
    },
    {
      label: "Resumo por categoria",
      value: "resumoContaCategoria",
    },
  ];

export const fieldsRelatorioVotosColumns: FieldRelatorioColumn<RelatorioVotosFields>[] =
  [
    {
      label: "Título da Pergunta",
      value: "perguntaTitulo",
      defaultChecked: true,
    },
    {
      label: "Total de Votos na Pergunta",
      value: "perguntaTotalVotos",
      defaultChecked: true,
    },
    {
      label: "Total de Peso na Pergunta",
      value: "perguntaTotalPeso",
      defaultChecked: true,
    },
    {
      label: "Título da Opção",
      value: "opcaoTitulo",
      defaultChecked: true,
    },
    {
      label: "Total de Votos na Opção",
      value: "opcaoTotalVotos",
      defaultChecked: true,
    },
    {
      label: "Total de Peso na Opção",
      value: "opcaoTotalPeso",
      defaultChecked: true,
    },
    {
      label: "Nome do Votante",
      value: "votanteNome",
      defaultChecked: false,
    },
    {
      label: "Unidades do Votante",
      value: "votanteUnidades",
      defaultChecked: false,
    },
    {
      label: "Peso Total do Voto Individual",
      value: "votantePesoTotal",
      defaultChecked: false,
    },
    {
      label: "Data/Hora do Voto",
      value: "votanteDataVoto",
      defaultChecked: false,
    },
  ];

export const fieldsPDFContasRecorrentesColumns: FieldRelatorioColumn<ContasRecorrentesFields>[] =
  [
    {
      label: "Resumo por categoria",
      value: "resumoContaCategoria",
      defaultChecked: true,
    },
  ];

export interface FiltroCertidaoNegativaForm {
  unidadeId: string;
  dataInicio: string;
  dataFim: string;
}

export interface CertidaoNegativaDebitosDto {
  usuario: {
    nome: string;
    perfilNome: string | null;
  };
  dadosAdministradoraTenant: {
    nome: string;
    endereco: string;
    email: string | null;
    fone: string | null;
  };
  dadosTenant: {
    nome: string;
    endereco: string;
    email: string | null;
    fone: string | null;
    logo: string | null;
    cidade: string;
    uf: string;
    tipoEstrutura: "vertical" | "horizontal";
    tipoHabitacao: TenantTipoHabitacao;
  };
  dadosUnidade: {
    responsavelNome: string;
    blocoQuadraNome: string | null;
    numero: string;
  };
  dataInicio: string | null;
  dataFim: string;
}

export interface BalancoFinanceiroOperacaoCategoriaItemConta {
  id: string;
  valorReferenteComposicao: number;
  competencia: string;
  formaPagamentoId: FormaPagamento;
  dataLiquidacao: string;
  notaFiscal: string | null;
  descricao: string | null;
}
export interface BalancoFinanceiroOperacaoCategoriaItem {
  id: string;
  breadcrumb: string;
  nome: string;
  total: number;
  categoriaFinanceiraPai?: {
    id: string;
    nome: string;
    breadcrumb: string;
  } | null;
  contas: BalancoFinanceiroOperacaoCategoriaItemConta[];
}
export interface BalancoFinanceiroOperacaoResponse {
  categorias: BalancoFinanceiroOperacaoCategoriaItem[];
}

export interface BalancoFinanceiroContaBancaria {
  id: string;
  nome: string;
  saldoAnterior: number;
  creditos: number;
  debitos: number;
  transferenciaSaida: number;
  transferenciaEntrada: number;
  total: number;
}

export interface BalancoFinanceiroReceitaResponse extends CategoriaFinanceiraResponse {
  valor: number;
  porcentagem: number;
  mesCompetencia: string;
  categoriaFinanceiraPaiId: string;
  valorItems: number;
  items: BalancoFinanceiroReceitaResponse[];
}
export interface BalancoFinanceiroResponse {
  receita: {
    categorias: BalancoFinanceiroReceitaResponse[];
  };
  despesa: BalancoFinanceiroOperacaoResponse;
  contasBancarias: BalancoFinanceiroContaBancaria[];
  totalReceita: number;
  totalDespesa: number;
  totalSaldoAnterior: number;
  saldoPeriodo: number;
  resultado: number;
}

export type BalancoFinanceiroPdfResponse = RelatorioBaseData &
  BalancoFinanceiroResponse;

export interface RelatorioReservasItem {
  id: string;
  areaComum: string;
  valor: number;
  dataEvento: string;
  horaInicio: string;
  createdAt: string;
  proprietario: string;
  status: StatusReservaEnum;
  unidade: string;
  blocoQuadra: {
    id: string;
    nome: string;
  };
  origem: ReservaCriacaoOrigem;
  dataCancelamento?: string | null;
  responsavelCancelamento?: {
    id: string;
    nome: string;
  } | null;
}

export interface TotaisRelatorioReservas {
  totalConfirmadas: number;
  totalPendentes: number;
  totalAguardandoPagamento: number;
  totalCanceladas: number;
}

export interface RelatorioReservasResponse extends TotaisRelatorioReservas {
  items: RelatorioReservasItem[];
}

export interface FiltroRelatorioReservas extends PaginateQuery {
  unidadeId: string;
  pessoaId: string;
  dataInicio: string;
  tipoData?: ReservaFiltroTipoData;
  dataFim: string;
  status?: StatusReservaEnum;
  tipoAreaComumIds?: Array<string>;
  areaComumId?: string;
}

export interface FiltroRelatorioUnidades extends PaginateQuery {
  gruposUnidadesIds: string[];
  situacaoAdimplencia?: "adimplente" | "inadimplente";
}

export interface RelatorioInadimplentesResponse extends TotaisRelatorioInadimplentes {
  numeroInadimplentes: number;
  totalUnidades: number;
  totalAcordos: number;
  items: RelatorioInadimplentesItem[];
}

export type RelatorioReservasPdfDataResponse = RelatorioBaseData &
  RelatorioReservasResponse;
